`<template>
  <transition name="fade">
    <div class="container-fluid" id="register">
      <script type="application/ld+json">
        {
          "@context": "http://schema.org",
          "@graph": [
            {
              "@type": "Article",
              "url": "https://www.teddi.co/garant/",
              "headline": "Garantie locative ← Teddi",
              "description": "Avec Teddi, louez votre logement en toute confiance ! Notre partenaire se porte garant pour couvrir loyers impayés et dégradations locatives",
              "datePublished": "2020-06-14T17:47:50.000Z",
              "dateModified": "2020-06-15T09:20:51.000Z",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://www.teddi.co/garant/"
              },
              "publisher": {
                "@type": "Organization",
                "@id": "https://www.teddi.co/",
                "name": "Teddi",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.teddi.co/assets/socials/fb-profile.png",
                  "width": 1000,
                  "height": 1000
                }
              },
              "author": {
                "@type": "Person",
                "name": "Thomas"
              }
            }
          ]
        }
      </script>
      <b-row class="pt-md-4 vh-100">
        <b-col md="5" offset-md="2" class="px-md-4">
          <div class="d-flex align-items-center py-3">
            <b-img
              v-if="isFirstStepView"
              class="icon-md mr-2"
              alt="folder"
              :src="require('@/assets/icons/folder.png')"
            >
            </b-img>
            <!-- BACK -->
            <b-img
              v-if="isSecondStepView"
              @click="switchToFirstStepView()"
              class="icon-md mr-2 cursor-pointer"
              alt="back-hands"
              :src="require('@/assets/icons/back-hands.svg')"
            >
            </b-img>
            <!-- BACK -->
            <h1>Votre dossier</h1>
          </div>

          <b-form class="text-left" @submit.prevent>
            <!-- FIRST STEP VIEW -->
            <div v-show="isFirstStepView">
              <div class="d-flex align-items-center">
                <h5 class="mb-0">Je suis</h5>
                <ProfessionalStatus />
              </div>
              <transition name="fade">
                <div class="d-flex align-items-center" v-if="professionalStatus">
                  <h5 class="mb-0">
                    le budget max de mon loyer
                  </h5>
                  <BudgetMax />
                </div>
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="professionalStatus && professionalStatus !== 1 && budgetMax"
                >
                  <h5 class="mb-0">
                    mes revenus sont de
                  </h5>
                  <MonthlyRevenues />
                </div>
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="
                    (professionalStatus !== 1 && monthlyRevenues >= 1) ||
                      (professionalStatus == 1 && budgetMax)
                  "
                >
                  <h5 class="mb-0">mon épargne actuelle est de</h5>
                  <Savings />
                </div>
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="
                    (professionalStatus !== 1 && monthlyRevenues > 1 && savings >= 1) ||
                      (professionalStatus == 1 && savings >= 1)
                  "
                >
                  <h5 class="mb-0">j'ai un référent de confiance</h5>
                  <ResponsibleParty />
                </div>
              </transition>
              <transition name="fade">
                <div class="d-flex align-items-center" v-if="responsibleParty">
                  <h5 class="mb-0">ses revenus</h5>
                  <ResponsiblePartyMonthlyRevenues />
                </div>
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="responsibleParty && responsiblePartyMonthlyRevenues"
                >
                  <h5 class="mb-0">son épargne</h5>
                  <ResponsiblePartySavings />
                </div>
              </transition>
            </div>
            <!-- SECOND STEP VIEW -->
            <transition name="fade">
              <div v-if="isSecondStepView">
                <transition name="fade">
                  <div class="d-md-flex align-items-center">
                    <h5 class="mb-md-0 mr-md-3">Mon email</h5>
                    <Email />
                  </div>
                </transition>
                <transition name="fade">
                  <div class="d-md-flex align-items-center" v-if="email && responsibleParty">
                    <h5 class="mb-md-0 mr-md-3">l'email de mon référent de confiance</h5>
                    <ResponsiblePartyEmail />
                  </div>
                </transition>
                <!--   <transition name="fade">
                  <div class="d-flex align-items-center" v-if="email">
                    <h5 class="mb-0 mr-3">ma pièce d'identité</h5>
                    <ID />
                  </div>
                </transition>
                <transition name="fade">
                  <div class="d-flex align-items-center" v-if="id && monthlyRevenues >= 1">
                    <h5 class="mb-0 mr-3">un justificatif de vos revenus</h5>
                    <ProofOfRevenues />
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    class="d-flex align-items-center"
                    v-if="
                      (id && savings >= 1 && professionalStatus == 1) ||
                        (id && savings >= 1 && monthlyRevenues >= 1 && professionalStatus !== 1)
                    "
                  >
                    <h5 class="mb-0 mr-3">un justificatif de mon épargne</h5>
                    <ProofOfSavings />
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    class="d-flex align-items-center"
                    v-if="
                      id && proofOfSavings && (professionalStatus == 1 || professionalStatus == 2)
                    "
                  >
                    <h5 class="mb-0 mr-3">mon certificat de scolarité</h5>
                    <SchoolCertificate />
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    class="d-flex align-items-center"
                    v-if="
                      (id && responsibleParty == 1 && schoolCertificate) ||
                        (responsibleParty !== 1 && id)
                    "
                  >
                    <h5 class="mb-0 mr-3">la pièce d'identité de mon référent de confiance</h5>
                    <ResponsiblePartyID />
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    class="d-flex align-items-center"
                    v-if="responsiblePartyID && responsibleParty == 1"
                  >
                    <h5 class="mb-0 mr-3">
                      un justificatif de revenus de mon référent de confiance
                    </h5>
                    <ResponsiblePartyProofOfRevenues />
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    class="d-flex align-items-center"
                    v-if="responsiblePartyProofOfRevenues && responsibleParty == 1"
                  >
                    <h5 class="mb-0 mr-3">
                      un justificatif d'épargne de votre référent de confiance
                    </h5>
                    <ResponsiblePartyProofOfSavings />
                  </div>
                </transition> -->
              </div>
            </transition>
          </b-form>
        </b-col>
        <!-- HELPER -->
        <b-col md="3" class="d-none d-md-block">
          <div class="d-flex align-items-center justify-content-center py-3">
            <b-img class="icon-md mr-2" alt="worker" :src="require('@/assets/icons/guard.png')">
            </b-img>
          </div>
          <FormHelper class="pb-5" />
        </b-col>
      </b-row>
      <!-- NEXT -->
        <div
          @click="switchToSecondStepView()"
          class="cursor-pointer d-flex justify-content-center fixed-bottom py-2 py-md-1 bg-blue"
          v-if="
            isFirstStepView &&
              ((professionalStatus == 1 && responsiblePartySavings >= 1) ||
                (professionalStatus !== 1 &&
                  responsibleParty !== 0 &&
                  responsiblePartySavings >= 1) ||
                (professionalStatus !== 1 && responsibleParty == 0))
          "
        >
          <IconNext class="icon white slide-right" />
        </div>
      <!-- SUBMIT -->
        <vue-recaptcha
          :loadRecaptchaScript="true"
          ref="invisibleRecaptcha"
          size="invisible"
          sitekey="6LfTAv0UAAAAAIqxP0ib1Y-RAbI4FLpah7Vf39VS"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
        >
          <div
            @click="recaptcha()"
            class="fixed-bottom py-2 py-md-1 bg-blue submit"
            v-if="
              isSecondStepView &&
                ((professionalStatus == 1 &&
                  responsiblePartySavings >= 1 &&
                  responsiblePartyMonthlyRevenues >= 1 &&
                  email &&
                  responsiblePartyEmail) ||
                  (professionalStatus !== 1 &&
                    responsibleParty == 1 &&
                    responsiblePartySavings >= 1 &&
                    responsiblePartyMonthlyRevenues >= 1 &&
                    monthlyRevenues >= 1 &&
                    savings >= 1 &&
                    email &&
                    responsiblePartyEmail) ||
                  (professionalStatus !== 1 &&
                    responsibleParty == 0 &&
                    monthlyRevenues >= 1 &&
                    savings >= 1 &&
                    email))
            "
          >
            <IconSubmit class="icon white" />
          </div>
        </vue-recaptcha>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Vue from "vue";
import VueRecaptcha from "vue-recaptcha";
import IconSubmit from "@/components/icons/IconSubmit.vue";
import IconNext from "@/components/icons/IconNext.vue";
import IconBack from "@/components/icons/IconBack.vue";

export default {
  metaInfo: {
    title: "Garantie locative",
    titleTemplate: "%s ← Teddi",
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Avec Teddi, louez votre logement en toute confiance ! Notre partenaire se porte garant pour couvrir loyers impayés et dégradations locatives",
      },
      {
        property: "og:title",
        content: "%s ← Teddi",
      },
      { property: "og:site_name", content: "Teddi" },
      { property: "og:type", content: "website" },
      {
        property: "og:url",
        content: "https://www.teddi.co/garant",
      },
      {
        property: "og:image",
        content: "https://www.teddi.co/assets/socials/fb-cover.jpg",
      },
      {
        property: "og:description",
        content:
          "Avec Teddi, louez votre logement en toute confiance ! Notre partenaire se porte garant pour couvrir loyers impayés et dégradations locatives",
      },
    ],
    link: [{ rel: "canonical", href: "https://www.teddi.co/garant" }],
  },
  components: {
    BudgetMax: () =>
      import(/* webpackChunkName:"BudgetMax"*/ "./../components/content/BudgetMax.vue"),
    ProfessionalStatus: () =>
      import(
        /* webpackChunkName:"ProfessionalStatus"*/ "./../components/content/ProfessionalStatus.vue"
      ),
    MonthlyRevenues: () =>
      import(/* webpackChunkName:"MonthlyRevenues"*/ "./../components/content/MonthlyRevenues.vue"),
    Savings: () => import(/* webpackChunkName:"Savings"*/ "./../components/content/Savings.vue"),
    ResponsibleParty: () =>
      import(
        /* webpackChunkName:"ResponsibleParty"*/ "./../components/content/ResponsibleParty.vue"
      ),
    ResponsiblePartyMonthlyRevenues: () =>
      import(
        /* webpackChunkName:"ResponsiblePartyMonthlyRevenues"*/ "./../components/content/ResponsiblePartyMonthlyRevenues.vue"
      ),
    ResponsiblePartyEmail: () =>
      import(
        /* webpackChunkName:"ResponsiblePartyEmail"*/ "./../components/content/ResponsiblePartyEmail.vue"
      ),
    ResponsiblePartySavings: () =>
      import(
        /* webpackChunkName:"ResponsiblePartySavings"*/ "./../components/content/ResponsiblePartySavings.vue"
      ),
    Email: () => import(/* webpackChunkName:"Email"*/ "./../components/content/Email.vue"),
    FormHelper: () =>
      import(/* webpackChunkName:"FormHelper"*/ "./../components/content/FormHelper.vue"),

    IconSubmit,
    VueRecaptcha,
    IconNext,
    IconBack,
  },
  data() {
    return {
      isRecaptchaValid: false,
    };
  },
  computed: {
    ...mapState({
      professionalStatus: state => state.optionalFields.professionalStatus,
      monthlyRevenues: state => state.optionalFields.monthlyRevenues,
      responsibleParty: state => state.optionalFields.responsibleParty,
      responsiblePartyEmail: state => state.optionalFields.responsiblePartyEmail,
      responsiblePartyMonthlyRevenues: state =>
        state.optionalFields.responsiblePartyMonthlyRevenues,
      responsiblePartySavings: state => state.optionalFields.responsiblePartySavings,
      savings: state => state.optionalFields.savings,
      budgetMax: state => state.userSearch.budgetMax,
      schoolCertificate: state => state.optionalFields.schoolCertificate,
      id: state => state.optionalFields.id,
      isFirstStepView: "isFirstStepView",
      isSecondStepView: "isSecondStepView",
      isPhoneValid: "isPhoneValid",
      email: state => state.userData.email,
      hasInputBeenChanged: "hasInputBeenChanged",
    }),
  },

  methods: {
    ...mapMutations({ setHasInputBeenChanged: "SET_HAS_INPUT_BEEN_CHANGED" }),
    switchToSecondStepView() {
      this.$store.commit("SET_FIRST_STEP_VIEW", false);
      this.$store.commit("SET_SECOND_STEP_VIEW", true);
    },
    switchToFirstStepView() {
      this.$store.commit("SET_FIRST_STEP_VIEW", true);
      this.$store.commit("SET_SECOND_STEP_VIEW", false);
    },
    recaptcha() {
      this.$refs.invisibleRecaptcha.execute();
    },
    onCaptchaExpired() {
      this.$refs.invisibleRecaptcha.reset();
    },
    async onCaptchaVerified(token) {
      this.$refs.invisibleRecaptcha.reset();
      await this.$store.dispatch("sendToPartnerGuarantor");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
h1 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0;
}
form {
  div.d-flex,
  div.d-md-flex {
    margin-bottom: 1rem;
  }
  padding-bottom: 8rem;
}
</style>
